export const SET_FAVICON = "SET_FAVICON";
export const ADD_FAVICON = "ADD_FAVICONS";
export const UPDATE_FAVICON = "UPDATE_FAVICONS";
export const GET_FAVICON = "GET_FAVICONS";
export const REFRESH_FAVICON = "REFRESH_FAVICON"
export const UPDATE_LOCKED = "UPDATE_LOCKED"
export const UPDATE_NEWS = "UPDATE_NEWS"